import React, { useEffect } from 'react';
import Button from '../Button/Button';
import styles from './ModalDelete.module.css';

interface ModalDeleteProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
  entity: string;
  title: string;
  isMobile: boolean;
}

const ModalDelete: React.FC<ModalDeleteProps> = ({ 
  isOpen, onClose, onConfirm, isDeleting, entity, title, isMobile 
}) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!isOpen) return;

      if (event.key === 'Escape') {
        onClose();
      }
      
      if (event.key === 'Enter' && !isDeleting) {
        onConfirm();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, isDeleting, onClose, onConfirm]);

  if (!isOpen) return null;

  return (
    <div 
      className={styles.overlay}
      onClick={() => !isDeleting && onClose()}
    >
      <div
        className={styles.modal}
        onClick={e => e.stopPropagation()}
      >
        {isMobile && <div className={styles.mobileIndicator} />}
        
        <div className={styles.icon}>🗑️</div>
        
        <h3 className={styles.title}>Deletar {entity}?</h3>
        
        <div className={styles.description}>
          <strong>"{title}"</strong> será marcado como excluído e não aparecerá mais na plataforma.
        </div>
        
        <div className={styles.buttonContainer}>
          <Button
            variant='contain'
            typeStyle={["full"]}
            onClick={onClose} 
            disabled={isDeleting}
          >
            Cancelar
          </Button>
          <Button 
            variant='contain'
            typeStyle={["cancel", "full"]}
            onClick={onConfirm} 
            disabled={isDeleting}
          >
            {isDeleting ? 'Excluindo...' : 'Sim, excluir'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ModalDelete;